<template>
  <nav aria-label="breadcrumb">
    <div class="bc-nav">
      <router-link v-if="!hideLogo" to="/" class="bc-logo-link">
        <img :src="$store.state.theme.darkMode ? logoShortLight : logoShortDark" alt="Graspil" class="bc-logo" />
      </router-link>

      <template v-for="(item, i) in $store.state.theme.breadcrumbs" :key="i">
        <span class="bc-sep">/</span>
        <router-link v-if="item.href" :to="item.href" class="bc-item">{{item.label}}</router-link>
        <span v-else class="bc-item">{{item.label}}</span>
      </template>

      <template v-if="$store.state.theme.h1">
        <span class="bc-sep">/</span>
        <span class="bc-current">{{ $store.state.theme.h1 }}</span>
      </template>
    </div>
  </nav>
</template>

<script>
import logoShortLight from "@/assets/img/graspil_short_logo_light.png";
import logoShortDark from "@/assets/img/graspil_short_logo_dark.png";

export default {
  name: "breadcrumbs",
  props: {
    textWhite: { type: String },
    hideLogo: { type: Boolean, default: false },
  },
  data() {
    return { logoShortLight, logoShortDark };
  },
};
</script>

<style scoped>
.bc-logo-link {
  display: flex;
  align-items: center;
  text-decoration: none;
}
.bc-logo {
  height: 22px;
  width: auto;
  object-fit: contain;
  display: block;
}
</style>
